<template>
    <button type="button" @click="show = true">
        <slot />
        <teleport v-if="show" to="#dropdown-teleport-target">
            <div>
                <div
                    style="position: fixed; top: 0; right: 0; left: 0; bottom: 0; z-index: 99998; background: black; opacity: 0.2"
                    @click="show = false"
                />
                <div ref="dropdown" style="position: absolute; z-index: 99999" @click.stop="show = !autoClose">
                    <slot name="dropdown" />
                </div>
            </div>
        </teleport>
    </button>
</template>

<script setup lang="ts">
import type { Placement, Instance as PopperInstance } from '@popperjs/core';
import { createPopper } from '@popperjs/core';
import { getCurrentInstance, onMounted, ref, useTemplateRef, watch } from 'vue';

const props = withDefaults(
    defineProps<{
        placement?: Placement;
        autoClose?: boolean;
    }>(),
    {
        autoClose: true,
        placement: 'bottom-end',
    },
);

const show = ref(false);
const dropdown = useTemplateRef<HTMLDivElement>('dropdown');
let popper: PopperInstance | null = null;

const instance = getCurrentInstance();

watch(show, (newShow) => {
    if (newShow) {
        setTimeout(() => {
            if (instance?.proxy?.$el && dropdown.value) {
                popper = createPopper(instance.proxy.$el, dropdown.value, {
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                altBoundary: true,
                            },
                        },
                    ],
                    placement: props.placement,
                });
            }
        });
    } else if (popper) {
        setTimeout(() => {
            popper?.destroy();
            popper = null;
        }, 100);
    }
});

onMounted(() => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            show.value = false;
        }
    });
});
</script>
